import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Admin = ({ userRights }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    adminLinks: { manageAccount, manageControl, manageProducts, automation }
  } = localizedStrings;

  return (
    <>
      {userRights.isAdminBandVisible && (
        <>
          {userRights.isAdminBandVisible && (
            <li>
              <div>
                <Link variant="link" to="/manage-control/dealerships">
                  <Typography variant={{ inverse: true }}>
                    {manageControl}
                  </Typography>
                </Link>
              </div>
            </li>
          )}
          {userRights.isUserPageVisible && (
            <li>
              <div>
                <Link variant="link" to="/users">
                  <Typography variant={{ inverse: true }}>
                    {manageAccount}
                  </Typography>
                </Link>
              </div>
            </li>
          )}
          {userRights.isProductCatalogVisible && (
            <li>
              <div
                style={
                  userRights.isAutomationVisible
                    ? undefined
                    : { marginRight: '15px' }
                }
              >
                <Link variant="link" to="/product-catalogue-dashboard">
                  <Typography variant={{ inverse: true }}>
                    {manageProducts}
                  </Typography>
                </Link>
              </div>
            </li>
          )}
          {userRights.isAutomationVisible && (
            <li>
              <div style={{ marginRight: '15px' }}>
                <Link
                  variant="link"
                  to="/automation"
                  style={{ borderRight: 'none' }}
                >
                  {/* Contentful may not carry this key yet, so fall back to the English label. */}
                  <Typography variant={{ inverse: true }}>
                    {automation || 'Automation'}
                  </Typography>
                </Link>
              </div>
            </li>
          )}
        </>
      )}
    </>
  );
};

Admin.propTypes = {
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool,
    isHardwareGridUploadVisible: PropTypes.bool,
    isProductCatalogVisible: PropTypes.bool,
    isAutomationVisible: PropTypes.bool
  }).isRequired
};

export default Admin;
